<template>
    <modal name="ActivityRequestModal"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto">
        <div class="popupcontainer vue-dialog">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="close()">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4>
                    활동 {{activityMember.isRegistered ? '취소':'신청'}}
                </h4>
            </div>
            <div style="margin-left: 5px;" class="modal-body" v-show="isRepeatableDayOfWeek">
                <p v-show="!activityMember.isRegistered"><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 활동 가능 요일을 선택해 주세요. </p>
                <p v-show="activityMember.isRegistered"><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 활동 가능 요일 </p>

                <div class="form-group form-check form-check-inline" >
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableMon" :disabled="activityMember.isRegistered" >
                    <label class="form-check-label">월</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableTue" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">화</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableWed" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">수</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableThu" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">목</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableFri" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">금</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableSat" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">토</label> &nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" class="form-check-input" v-model="activityMember.isRepeatableSun" :disabled="activityMember.isRegistered">
                    <label class="form-check-label">일</label>
                </div>

                <br/>
                <br/>
                <p><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 더봄센터 봉사활동 중 원하는 봉사지를 선택해주세요.</p>

                <div class="hstack">
                    <!--                    <input type="radio" v-model="activityMember.transportation" value="대중교통" /> 대중교통-->
                    <!--                    <input type="radio" v-model="activityMember.transportation" class="ml-3" value="자차" /> 자차-->
                    <!--                    <input type="radio" v-model="activityMember.transportation" class="ml-3" value="other" /> 기타-->
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="activityMember.volunteerPlace" id="placeRadio1" value="1f" @click="removeTransportText()">
                        <label class="form-check-label" for="placeRadio1">
                            1층 견사(중대형견)
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.volunteerPlace" id="placeRadio2" value="2f" @click="removeTransportText()">
                        <label class="form-check-label" for="placeRadio2">
                            2층 견사(중소형견)
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.volunteerPlace" id="placeRadio3" value="cat">
                        <label class="form-check-label" for="placeRadio3">
                            묘사
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.volunteerPlace" id="placeRadio5" value="lobby">
                        <label class="form-check-label" for="placeRadio5">
                            로비
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.volunteerPlace" id="placeRadio4" value="other">
                        <label class="form-check-label" for="placeRadio4">
                            기타
                        </label>
                    </div>
                </div>
                
                <div v-if="false">
                <br/>
                <br/>
                    <p><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 더봄에서 제공되는 점심 식사를 신청 하시겠습니까?(비건 식단) </p>

                    <div class="hstack">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" v-model="activityMember.isAppliedLunchbox" id="LunchboxRadio1" value="true">
                            <label class="form-check-label" for="LunchboxRadio1">
                                예
                            </label>
                        </div>
                        <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" v-model="activityMember.isAppliedLunchbox" id="LunchboxRadio2" value="false">
                            <label class="form-check-label" for="LunchboxRadio2">
                                아니오
                            </label>
                        </div>
                        <div class="form-check ml-3">
                            <input class="form-check-input" type="radio" v-model="activityMember.isAppliedLunchbox" id="LunchboxRadio3" value="">
                            <label class="form-check-label" for="LunchboxRadio3">
                                해당사항 없음
                            </label>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <p><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 봉사지로 오시는 교통수단을 선택해 주세요.<br> &nbsp;&nbsp;- [더봄센터↔문산역] 셔틀버스 이용가능 </p>

                <div class="hstack">
<!--                    <input type="radio" v-model="activityMember.transportation" value="대중교통" /> 대중교통-->
<!--                    <input type="radio" v-model="activityMember.transportation" class="ml-3" value="자차" /> 자차-->
<!--                    <input type="radio" v-model="activityMember.transportation" class="ml-3" value="other" /> 기타-->
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="activityMember.transportation" id="transportRadio1" value="대중교통" @click="removeTransportText()">
                        <label class="form-check-label" for="transportRadio1">
                            대중교통
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.transportation" id="transportRadio2" value="자차" @click="removeTransportText()">
                        <label class="form-check-label" for="transportRadio2">
                            자차
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.transportation" id="transportRadio3" value="other">
                        <label class="form-check-label" for="transportRadio3">
                            기타
                        </label>
                    </div>
                    <input type="text" v-model="transportationText" class="form-control ml-3" style="max-width:30%" :readonly="activityMember.transportation != 'other'" />
                </div>


                <br>
                <br>
                <p><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 매주 선택한 요일에 봉사오는 것을 확인했습니다. <br> &nbsp;&nbsp;- 못오시는 일정이 있다면 메모란에 남겨주세요. </p>


                <div class="hstack">
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.isConfirmDayOfWeek" id="dayOfWeekRadio1" value="true">
                        <label class="form-check-label" for="dayOfWeekRadio1">
                            예
                        </label>
                    </div>
                    <div class="form-check ml-3">
                        <input class="form-check-input" type="radio" v-model="activityMember.isConfirmDayOfWeek" id="dayOfWeekRadio2" value="false">
                        <label class="form-check-label" for="dayOfWeekRadio2">
                            아니오
                        </label>
                    </div>
                </div>



            </div>
            <br/>
            <h5 style="margin-left: 20px;">메모</h5>

            <div style="margin-left: 5px;" class="modal-body">
                <p v-show="!activityMember.isRegistered"><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 활동을 신청하게된 동기 혹은 하고 싶은 말을 적어주세요. </p>
                <p v-show="activityMember.isRegistered"><span class="badge badge-pill badge-secondary" style="font-size:12px"  >!</span> 신청시 등록한 메모내용 </p>
                <textarea v-model="activityMember.description" :disabled="activityMember.isRegistered" class="form-control"></textarea>

            </div>
            <br/>

            <div class="vue-dialog-buttons">
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="apply()">{{activityMember.isRegistered ? '취소':'신청'}}하기</button>
                <button type="button" class="vue-dialog-button" style="flex: 1 1 50%;" @click="close()">닫기</button>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        name: "ActivityRequestModal",
        props: {
            activity: Object,
            activityMember: Object,
            isRepeatableDayOfWeek: Boolean,
        },
        data() {
            return {
                transportationText : '',
            }
        },
        computed: {
        },
        methods: {
            apply() {
                if(this.isRepeatableDayOfWeek && !this.activityMember.isRegistered) {
                    if(!this.activityMember.isRepeatableMon && !this.activityMember.isRepeatableTue && !this.activityMember.isRepeatableWed
                        && !this.activityMember.isRepeatableThu && !this.activityMember.isRepeatableFri && !this.activityMember.isRepeatableSat && !this.activityMember.isRepeatableSun) {
                        alert('활동 가능 요일을 선택해주세요.');
                        return false;
                    }

                    if(this.activityMember.transportation == "other"){
                        if(this.transportationText.length > 0){
                            this.activityMember.transportation = this.transportationText;
                        }else{
                            alert('교통수단을 입력해주세요.');
                            return false;
                        }
                    }
                }

                this.$emit('before-close', this.activityMember)

                this.close();
            },
            close() {
                this.$modal.hide('ActivityRequestModal')
            },
            removeTransportText(){
                this.transportationText = '';
            }
        },
        mounted() {
        },
        created() {
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        border-radius: 5px;
        background: #F7F7F7;
        max-height: 600px;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }

    .hstack {
        display: flex;
        flex-direction: row;
        align-items: center;
        align-self: stretch;
    }

    .ml-3{
        margin-left : 3px;
    }

</style>